import { Fragment } from 'react';
import { StyledField, SelectField } from '../../fields';

export default function StopCheckParameters({ name, filters }) {
  return (
    <Fragment>
      <StyledField
        name={`${name}.areas^bcu^name`}
        component={SelectField}
        label="BCU"
        values={(filters.bcus || []).map((item) => {
          return { value: item.name, label: item.name };
        })}
      />
      <StyledField
        name={`${name}.areas^localAuthority^name`}
        component={SelectField}
        label="Local Authority"
        values={(filters.localAuthorities || []).map((item) => {
          return { value: item.name, label: item.name };
        })}
      />
      <StyledField
        name={`${name}.areas^section^name`}
        component={SelectField}
        label="Section"
        values={(filters.sections || []).map((item) => {
          return { value: item.name, label: item.name };
        })}
      />
      <StyledField
        name={`${name}.areas^sector^name`}
        component={SelectField}
        label="Sector"
        values={(filters.sectors || []).map((item) => {
          return { value: item.name, label: item.name };
        })}
      />
      <StyledField
        name={`${name}.areas^beat^name`}
        component={SelectField}
        label="Beat"
        values={(filters.beats || []).map((item) => {
          return { value: item.name, label: item.name };
        })}
      />
      <StyledField
        name={`${name}.areas^ward^name`}
        component={SelectField}
        label="Ward"
        values={(filters.wards || []).map((item) => {
          return { value: item.name, label: item.name };
        })}
      />
    </Fragment>
  );
}
